import React, {useContext, useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {Context} from "../index";
import {observer} from "mobx-react-lite";
import {jwtDecode} from "jwt-decode";
import {checkAuth} from "../http/userAPI";
import Auth from "../pages/Auth";

const RequireAuth = observer(({children}) => {
    const location = useLocation();
    const {user} = useContext(Context);
    const navigate = useNavigate();
    if ('token' in localStorage) {
        user.setUserId(jwtDecode(localStorage.getItem('token')).issuer_id)
    } else {
        user.setUserId(null)
        user.setIsAuth(false);
        navigate('/auth')
    }

    const load = async () => {
        try {
            const {data} = await checkAuth(user.userId)
            user.setUserId(data.id);
            user.setIsAuth(true);
            user.setUser('email', data.email)
        } catch (e) {
            user.setUserId(null);
            user.setIsAuth(false);
            navigate('/auth')
        }
    }

    useEffect(() => {
        if (location.pathname !== '/things') {
            navigate('/things')
        }
        load().then()
    }, [])

    // useEffect(() => {
    //     if (user.userId === null) {
    //         user.setIsAuth(false);
    //         navigate('/auth')
    //     } else load().then(() => {
    //         return user.isAuth ? children : <Auth/>
    //     });
    // })
    return user.isAuth ? children : <Auth/>
});

export default RequireAuth;